import { render } from "./AiTableBlock.vue?vue&type=template&id=d13177ea&scoped=true"
import script from "./AiTableBlock.vue?vue&type=script&lang=js"
export * from "./AiTableBlock.vue?vue&type=script&lang=js"

import "./AiTableBlock.vue?vue&type=style&index=0&id=d13177ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13177ea"]])

export default __exports__